!function(module){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('common/utils',['libs/ct_store', 'ct_utils'], module)
	else
	//>>excludeEnd("requireTmpl");
		module(CT.Store)
}(function(store){
	$.extend(true, CT.utils, {
		CTLogger: (function($){
			var init = true;
			var dr_tr = false;
			var _dr;
			var _tr;
			var trackHotelURLs = ['hotel-content','scData','sid-result'];
			var trackAirURLs = ['airjson'];
			var unTrackAirParameters = ['dls=y'];
			var unTrackHotelParameters = [];
	
			var serverLogs = [];
			var requestPool = [];
			var hotelCallsPool = [];
			var calculateInterval;
	
			function Request(url,startTime){
				this.url = url;
				this.startTime = startTime;
	
			};
	
			function addNewRequest(obj, logTime){
				
				var request = new Request(obj.url, new Date().getTime());
				return logTime? (hotelCallsPool.push(request) - 1) : (requestPool.push(request) - 1)
			
			}
	
			function checkTrackURL(url){
				var t_urls = (CT.app === "hotel") ? trackHotelURLs : trackAirURLs;
				for(var i=0,len= t_urls.length; i < len ; i++)
					{
						if(url.search(t_urls[i]) > -1)
							{
								return true;
							}
					}
	
				return false;	
			}
	
			function checkUnTrackParameters(url)
			{
				var t_urls = (CT.app === "hotel") ? unTrackHotelParameters : unTrackAirParameters;
	
				for(var i=0,len= t_urls.length; i < len ; i++)
					{
						if(url.search(t_urls[i]) > -1)
							{
							return false;
							}
					}
	
				return true;
	
			}
	
	
			function initialize(){
				$.ajaxSetup({
					beforeSend : function(request) {
						try{
							if(checkTrackURL(this.url) && checkUnTrackParameters(this.url)){
									request.CTLoggerID = addNewRequest(this);
									if(requestPool.length > 1){
										//requestPool[request.CTLoggerID].delay = (new Date().getTime()) - requestPool[(request.CTLoggerID - 1)].endTime;
										if(requestPool[(request.CTLoggerID - 1)].endTime){
											requestPool[request.CTLoggerID].delay = (new Date().getTime()) - requestPool[(request.CTLoggerID - 1)].endTime;
										}
										else{
											requestPool[request.CTLoggerID].delay = (new Date().getTime()) - requestPool[(request.CTLoggerID - 1)].startTime;
										}
									}
								}
							
							if(CT.app === "hotel" && (this.url.match('sid-results') || this.url.match('hotel-content') || this.url.match('scData'))){								
								request.logThisCall = addNewRequest(this, "hotelTrack");
								var getSidIndex = _.deserialize(this.url).index;
								var getSidCount = _.deserialize(this.url).count;
								// Enable search button when an option is selected from suggestions
								if ($("#SearchHotelsButton")) {
									$("#SearchHotelsButton").removeAttr('disabled');
								}
								console.log(getSidIndex+" "+getSidCount+" "+JSON.stringify(_.deserialize(this.url)));
								var setStartTime = {s: new Date().getTime(), index: getSidIndex, count : getSidCount}
								CT.cache[CT.settings.currentTab].eventsTimes.sid[request.logThisCall] = setStartTime; 
							}
							if(CT.app=== "air" && (this.url.match('airjson') || this.url.match('dd-'))){
								var url =  _.deserialize(this.url);
								if(url.dls != 'y'){
									var getSidIndex = url.cc;
									request.logThisCall = addNewRequest(this, "airTrack");
                                	var setStartTime = {s: new Date().getTime(), index: getSidIndex}
									CT.cache[CT.settings.currentTab].eventsTimes.sid[request.logThisCall] = setStartTime; 
								}
								if(window.flightPageId){
					    	    	try{
					    		    	var fltPageId = window.flightPageId;
					    		    	var arr = fltPageId.split('');
					    		    	arr.splice(-3);
					    		    	fltPageId = arr.splice(3);
					    		    	fltPageId = fltPageId.reverse().join('');
					    		    	fltPageId = window[fltPageId].split('').reverse().join('').split('.').map(function(r){
					    		    		return r
					    		    	}).reverse().join('.');
					    		    	request.setRequestHeader('Authorization','Bearer '+ fltPageId );
					    		    	return fltPageId;
					    	    	}catch(e){
					    	    		L(e);
					    	    		return '0';
					    	    	}
					    	    }
								
							}
							
						}catch(e){
	
						}
	
					},
	
					error: function(request, textStatus){
						try{
							if(request.hasOwnProperty('CTLoggerID')){
	
									requestPool[request.CTLoggerID].endTime = new Date().getTime();
									requestPool[request.CTLoggerID].status = textStatus;
	
							}
						}catch(e){
	
						}
					},
	
	
	
					success : function(data,textStatus, request) {
						try{
							if(request.hasOwnProperty('CTLoggerID')){
	
									requestPool[request.CTLoggerID].endTime = new Date().getTime();
									requestPool[request.CTLoggerID].status = textStatus;
	
							}
							
							if(CT.app === "hotel" && request.hasOwnProperty('logThisCall') ){
								CT.cache[CT.settings.currentTab].eventsTimes.sid[request.logThisCall]["e"] = new Date().getTime(); 
								var resultsObj = jQuery.parseJSON(request.responseText).results.ht;
								// console.log("success"+"   "+JSON.stringify(resultsObj));
								var resultsLength = $.map(resultsObj, function(value, key) { return key; }).length;
								//CT.cache[CT.settings.currentTab].eventsTimes.sid[request.logThisCall]["r"] = resultsLength;
								CT.cache[CT.settings.currentTab].eventsTimes.sid[request.logThisCall]["r"] = _.filter(resultsObj, function(value, key) { return value.rms && value.rms.length > 0 }).length;
							}	
							if(CT.app === "air" && request.hasOwnProperty('logThisCall') ){
								var url = _.deserialize(this.url);
								if(url.dls != 'y'){
									CT.cache[CT.settings.currentTab].eventsTimes.sid[request.logThisCall]["e"] = new Date().getTime(); 
									var resultsRes = jQuery.parseJSON(request.responseText);
								    var resultsObj = resultsRes.content;
									var resultsLength = $.map(resultsObj, function(value, key) { return key; }).length;
									CT.cache[CT.settings.currentTab].eventsTimes.sid[request.logThisCall]["r"] = resultsLength;
									CT.cache[CT.settings.currentTab].eventsTimes.sid[request.logThisCall]["sid"] = resultsRes.sid;
								}
							}
							
						}catch(e){
	                       
						}
					},
	
					complete : function(request,textStatus) {
	
						try{
							if(request.hasOwnProperty('CTLoggerID')){
	
	
							requestPool[request.CTLoggerID].completeTime = new Date().getTime();
							requestPool[request.CTLoggerID].status = textStatus;
	
	
							}
						}catch(e){
	
						}
	
	
	
					}
	
				});
			}
	
			function calculateRunTimeResults(json){
	
	
				//console.log("Calculate Run Time Results");
					if(allRequestsCompleted())
					{
						//console.log("All Request Complete");
						for(var i=0,len=requestPool.length; i < len; i++)
						{
							if( requestPool[i].completeTime){
							requestPool[i].runTime = requestPool[i].completeTime -  requestPool[i].startTime;
							}
							else{
								requestPool[i].runTime = requestPool[i].endTime -  requestPool[i].startTime;
							}
						}
	
						if(calculateInterval){
						clearInterval(calculateInterval);
						}
	
						json.t = (json.ty === 'hsr') ? tForHotels() : tForAir();
	
						json.tot = (function(){
	
							var sum = 0;
	
							for(var i=0,len = json.t.length; i<len; i++){
								var newAr = _.values(json.t[i]);
	
								sum = sum + Int(newAr[2]);
	
	
								}
	
							return String(sum);
	
						})();
					// logging removed as it no longer being used.
					/**
						$.ajax({ type: "POST", url : '/lst', data: JSON.stringify(json),
							global : false,
							contentType : "application/json",
							success: function(){ },
							complete: function(){ }
	
						}).done(function(){
							requestPool = [];
							serverLogs.push(json);
							calculateInterval = null;
							dr_tr = false;
							_dr = 0;
							_tr = 0;
						}).fail(function(){
							requestPool = [];
							serverLogs.push(json);
							calculateInterval = null;
							dr_tr = false;
							_dr = 0;
							_tr = 0;
						});
	 				**/
	
					if(CT.app === "hotel") {
						if(allRequestsCompleted()) {
							var getData =CT.cache[CT.settings.currentTab].searchParams.all;
							var ctsearchData=CT.utils.trackers.mixpanelTrackingData;
							var formLogData = {
									searchData:ctsearchData,
									es : CT.cache[CT.settings.currentTab].eventsTimes
							}
							//formLogData = $.extend(true, {}, formLogData, CT.utils.postParams);
							//CT.cache[CT.settings.currentTab].eventsLogger = formLogData; 
							//CT.cache[CT.settings.currentTab].sendLoggedData = true;
							CT.utils.trackers.ctanalyticsTrackingData('Hotels_TR','srp_render_time','srp_results_complete',formLogData,"time");
						}
					}
					if(CT.app === "air" ){
					  try{
	                       if(allRequestsCompleted()){
	                       	var getAirData=CT.utils.trackers.ctanalyticsTrackingobj;
	                       	CT.cache[CT.settings.currentTab].eventsTimes.sid = _.filter(CT.cache[CT.settings.currentTab].eventsTimes.sid,function(i){ return i });
	                       	getAirData._airjsonCount = String(CT.cache[CT.settings.currentTab].eventsTimes.sid.length);
	                       	var formAirlogData={
	                       		searchData:getAirData,
	                       		es: CT.cache[CT.settings.currentTab].eventsTimes
	                       	};
	                       	CT.fire("logSrpRenderTime",[{renderTimeData:formAirlogData}]);
	                       }
					  }catch(e){
						  
					  }
                    }					
				}
	
				else
					{
					//console.log("Request Not Complete");
						if(!calculateInterval)
							{
						calculateInterval = setInterval(function(){
							calculateRunTimeResults(json);
							}, 10);
							}
					}
			}
	
			function allRequestsCompleted(){
	
	
				var falseResults = 0;
	
				//console.log("Length ->", requestPool.length);
				for(var i=0,len=requestPool.length; i < len; i++)
				{
	
	
					if(!requestPool[i].completeTime)
						{
							falseResults = falseResults + 1;
						}
	
	
				}
	
				if(falseResults === 0)
					{
                        window.console && console.log(CT.cache[CT.settings.currentTab].eventsTimes.totalRenderTime); 
						return true;
					}
				else{
				return false;
				}

	
			}
	
	
			function getAllRequests(){
				return requestPool;
			}
	
	
			function showResults(){
				var CTLoggerDiv = document.createElement('div');
				CTLoggerDiv.zIndex = 9999;
				CTLoggerDiv.id = "CTLoggerDiv";
	
				var html = [];
				html.push( "<a href='javascript:CT.utils.CTLogger.closeResults()'>Close</a>");
				html.push("<br/><br/>");
	
				for(var i=0,len=requestPool.length; i < len; i++)
				{
					html.push(i+".)"+" URL-> "+requestPool[i].url+"  runTime -> "+requestPool[i].runTime+"<br/>");
				}
	
				CTLoggerDiv.innerHTML = html.join('');
				document.body.appendChild(CTLoggerDiv);
	
				CTLoggerDiv.style.backgroundColor = "#000000";
				CTLoggerDiv.style.padding = "50px";
				CTLoggerDiv.style.color = "#FFFFFF";
				CTLoggerDiv.style.height= "500px";
				CTLoggerDiv.style.width= "700px";
				CTLoggerDiv.style.position = "absolute";
				CTLoggerDiv.style.top = "80px";
				CTLoggerDiv.style.left = "150px";
			}
	
			function closeResults(){
				document.getElementById('CTLoggerDiv').style.display = "none";
			}
	
	
			function makeJSON(){
				var serverJSON = {};
				var masterJson = CT.masterJson.get()
				serverJSON.ty = (CT.app === "hotel") ? 'hsr' : 'asr';
	
				if(CT.settings.hotel && CT.settings.hotel.sid){
					serverJSON.sid = String(CT.settings.hotel.sid);
				}
	
				/*
				if(serverJSON.ty === 'asr' && CT.masterJson.get() && CT.masterJson.get().sid){
	
					serverJSON.sid =  CT.masterJson.get().sid;
	
				} */
	
				if(CT.settings.air && CT.settings.air.sid){
					serverJSON.sid = String(CT.settings.air.sid);
				}
	
				serverJSON.b = getUserAgent();
	
				serverJSON.dr = _dr ? String(_dr) : "0";
				serverJSON.tr = _tr ? String(_tr) : "0";
	
				if(serverJSON.ty === 'asr' && masterJson){
					serverJSON.intl = masterJson.jsons.searchType.isIntl ? 1 : 0;
	
					if(masterJson.jsons.expiredSuppliers){
						serverJSON.exsup = _.keys(masterJson.jsons.expiredSuppliers);
						if(JSON.intl)
						{
							for(var i=0, len = serverJSON.exsup.length; i< len; i++)
							{
								var tempArr = serverJSON.exsup[i].split('_');
								serverJSON.exsup[i] = tempArr[0];
	
								if(tempArr[1])
									{
									serverJSON.exsup[i] = tempArr[0]+'_'+tempArr[1];
									}
							}
						}
						else
							{
								for(var i=0, len = serverJSON.exsup.length; i< len; i++)
									{
										serverJSON.exsup[i] = serverJSON.exsup[i].split('_')[0];
									}
							}
	
	
	
					}
	
					serverJSON.intl = String(serverJSON.intl);
	
	
				}
	
				/*
				if(serverJSON.ty === "hsr" && (typeof CT.masterJson.get().err.zr != undefined) ){
	
					if(CT.masterJson.get() && ($.isEmptyObject(CT.masterJson.get().mapping) || CT.masterJson.get().mapping["0"].length == 0)){
						serverJSON.zr = "1";
					}
	
					serverJSON.dr = "0";
					serverJSON.dr = "0";
	
				} */
	
				serverJSON.url = window.location.href;
	
				if(serverJSON.ty === "asr")
					{
						if(_dr != _tr)
							{
								if(typeof masterJson != undefined && masterJson)
									serverJSON.fd = JSON.stringify(masterJson.jsons.filterRanges);
							}
	
					}
	
				return serverJSON;
			}
	
	
			function getUserAgent(){
				var browser;
				if($.browser.webkit)
					browser =  "webkit";
	
				if($.browser.opera)
					browser = "opera";
	
				if($.browser.msie)
					browser = "msie";
	
				if($.browser.mozilla)
					browser =  "mozilla";
	
				if(!browser)
					{
					browser = "other";
					}
	
				return browser + " "+ $.browser.version;
			}
	
	
			function tForHotels(){
				var t = [];
	
				for(var i=0,len=requestPool.length; i < len; i++)
					{
						var tObj = {}, dObj = {};
						tObj.c = (requestPool[i].url.search('scData') >= 1) ? 'SO' : (requestPool[i].url.search('hotel-content') >= 1) ? 'SC' : 'DL';
						dObj.c = tObj.c;
						tObj.tt = 't';
						dObj.tt = 'd';
						tObj.t = String(parseInt((requestPool[i].runTime) ? requestPool[i].runTime : 0));
	
						/*
						if(tObj.c === 'r'){
							tObj.i = String(CT.settings.hotel.updateCallIndex - 1);
						} */
	
						tObj.i = String(i+1);
	
						dObj.i = tObj.i;
	
						if(requestPool[i].delay)
							{
						dObj.t = String(requestPool[i].delay);
							}
	
						if(requestPool[i].status){
	
								if(requestPool[i].status != "success" && requestPool[i].status != "notmodified")
								{
									tObj.f = "1";
	
								}
	
							if(requestPool[i].status == "timeout"){
								tObj.f = "2";
							}
	
						}
	
						t.push(tObj);
	
						if(dObj.t){
							t.push(dObj);
						}
					}
	
				return t;
			}
	
	
			function tForAir(){
				var t = [];
	
				for(var i=0,len=requestPool.length; i < len; i++)
					{
						var tObj = {}, dObj = {};
	
						//tObj.c = (i == 0) ? "SC" : ((i==1) ? "SR" : "DL");
						tObj.c = (i==0) ? "SR" : "DL";
	
						dObj.c = tObj.c;
						tObj.tt = 't';
						dObj.tt = 'd';
						tObj.t = String(parseInt((requestPool[i].runTime) ? requestPool[i].runTime : 0));
	
						if(requestPool[i].delay){
						dObj.t = String(requestPool[i].delay);
						}
	
						tObj.i = String(i+1);
						dObj.i = tObj.i;
	
						if(requestPool[i].status){
	
							if(requestPool[i].status != "success" && requestPool[i].status != "notmodified")
							{
								tObj.f = "1";
	
							}
	
						if(requestPool[i].status == "timeout"){
							tObj.f = "2";
						}
	
					}
	
						t.push(tObj);
	
						if(dObj.t){
						t.push(dObj);
						}
					}
	
				return t;
			}
	
	
			function logToServer(){
	
				if(init){
				var json = makeJSON();
	
				calculateRunTimeResults(json);
	
			
				
	
				}
	
	
			}
	
	
	
			function getServerLogs(){
				return serverLogs;
			}
	
			function storeDRTR(dr, tr){
				if(!dr_tr){
					//if(typeof _dr != 'undefined')
					//	{
					 _dr = dr;
						//}
					 _tr = tr;
					 dr_tr = true;
				}
			}
	
			function storeDR(dr){
	
				_dr = dr;
	
			}
	
	
			if(init){
				initialize();
			}
	
	
	
			return {
				calculateRunTimeResults : calculateRunTimeResults,
				getAllRequests : getAllRequests,
				showResults : showResults,
				closeResults : closeResults,
				makeJSON : makeJSON,
				getServerLogs : getServerLogs,
				logToServer : logToServer,
				storeDRTR : storeDRTR,
				storeDR : storeDR
			}
	
		})(jQuery),
		
		cloneUpsellBanner : function (flightType){
			function updateInternationalBanner(fType, $upsellBanner){
				if(fType == 'intl'){
					var $freedomFare = $('#freedomFareBanner');
					if(!$freedomFare.length)
						return false
					$upsellBanner.find('.container').replaceWith($freedomFare.show());
				}
				return true;
			}
			if(flightType == 'dom'){
				var $upsellBanner = $("#srpUpsellBanner[data-flight-type='"+flightType+"'].baseContent").first();
			}else{
				var $upsellBanner = $("#srpUpsellBanner.baseContent:first").first();
			}
			if(!$upsellBanner[0])
				return false;
			
			
			var bannerIndex = 5;
			var $resultContainer = $('#ResultContainer_' + CT.settings.currentTab);
			var $existingBanner = $resultContainer.find('#srpUpsellBanner');
			var $listItems;
			var $referenceItem;
			
			if($existingBanner.length == 0){
				bannerIndex = $upsellBanner.attr("banner-index") || bannerIndex;
				$listItems = $resultContainer.find(".listItem");
				$referenceItem = $($listItems[bannerIndex-1]);
				
				if($referenceItem.next().hasClass('auxiliary')){
					$referenceItem = $referenceItem.next();
				}
				if(updateInternationalBanner(flightType, $upsellBanner))
					$upsellBanner.clone(true).removeClass('baseContent').insertAfter($referenceItem).show();
			}
		},
		
		clonePackagesUpsellBanner : function (destinationCode, destinationHash, stub){
		
			var $upsellBanner = $("#srpUpsellBanner[data-flight-type='dom'].baseContent").first();
		
			if(!$upsellBanner[0])
				return false;
		
			var bannerIndex = 5;
			var $resultContainer = $('#ResultContainer_' + CT.settings.currentTab);
			var $existingBanner = $resultContainer.find('#srpUpsellBanner');
			var $listItems;
			var $referenceItem;
			var $upsellBannerClone;
			
			if($existingBanner.length == 0){
				bannerIndex = $upsellBanner.attr("banner-index") || bannerIndex;
				$listItems = $resultContainer.find(".listItem");
				$referenceItem = $($listItems[bannerIndex-1]);
				
				if($referenceItem.next().hasClass('auxiliary')){
					$referenceItem = $referenceItem.next();
				}
				
				$upsellBannerClone = $upsellBanner.clone(true);
				$upsellBannerClone.find("img").attr({
					"style":"width:732px;height:108px",
					"src":"/html-templates/banner/images/packages/"+destinationCode+".jpg",
					"srcset":"/html-templates/banner/images/packages/"+destinationCode+".jpg"});
				$upsellBannerClone.find("a").attr("href",stub+"/"+destinationHash[destinationCode]);
				$upsellBannerClone.removeClass('baseContent').insertAfter($referenceItem).show();
			}
	}
	
	});
	
	/*=========================== Onload function triggers ================================*/
	$(function() {
	// 	if (CT.utils.cookies.read('booking') || CT.utils.cookies.read('bookedFlight')){
	// 		$('.toolsFlight').css('display', 'block');
	// 		window._gaq = window._gaq || []; 
	// 		_gaq.push(['_trackEvent', 'account', 'trip_tools_load', 'flights']);
	// 	}
	// if (CT.utils.cookies.read('booking') || CT.utils.cookies.read('bookedHotel')){
	// 		$('.toolsHotel').css('display', 'block');
	// 		window._gaq = window._gaq || []; 
	// 		_gaq.push(['_trackEvent', 'account', 'trip_tools_load', 'hotels']);
	// 	}
	});
   
});




